<template>
  <td :class="styling || ''">
    <span v-if="styling === 'streak' || styling === 'score'">{{(time && time !== Infinity) ? time : '0'}}</span>
    <span v-else>{{time ? (time !== Infinity ? time.toFixed(2) : 'DNF') : '-'}}</span>
    <br/>

    <span v-if="styling === 'streak' || styling === 'score'">{{(best && best !== Infinity) ? best : '0'}}</span>
    <span v-else>{{(best && best !== Infinity) ? best.toFixed(2) : '-'}}</span>
    <br />
  </td>
</template>

<script>
export default {
  name: 'session-single-stat',
  data () {
    return {}
  },
  props: {
    time: Number,
    best: Number,
    styling: String,
  },
  computed: {
    displayTime () {
      if (this.time.time === Infinity || this.time.DNF) {
        return 'DNF'
      } else if (this.time.plusTwo) {
        return (this.time.time + 2).toFixed(2) + '+' + (this.time.comment ? '*' : '')
      } else {
        return this.time.time.toFixed(2) + (this.time.comment ? '*' : '')
      }
    }
  },
  created () {
  }
}
</script>

<style scoped>
</style>
